import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { SellerAPI } from "../../Apis/sellerAPI";
import { CommonAPI } from "../../Apis/commonApi";
import { EventInterface, BuyerInterface } from "../../Interface/CommonInterface";
import { MEETING_REQUEST_STATUS, Sellerscreens } from "../../Constants/data";
import { errorHandler } from "../../Utils/handler";
import { isNewMeetingAllowed } from "../../Utils/meetingUtils"; // Claude: shared util 10-04-2026
import { useToastWrapper } from "../../Wrapper/toastWrapper";
import actions from "../../redux/Actions";

// Claude: extracted from BuyersList.tsx 23-03-2026
const useBuyersListState = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user);
  const filterToggleRef = useRef<HTMLButtonElement>();
  const isInitialRender = useRef(true);
  const [searchParams, setSearchParams] = useSearchParams();

  const { success, error } = useToastWrapper();

  const [relevanceData, setRelevanceData] = useState({
    prequalified_company_name: "",
    prequalified_user_id: [] as any[],
    event_id: "",
    status: "Under_Research",
  });

  const [sortModal, setSortModal] = useState(false);
  const handleOpenSortModal = () => setSortModal(true);
  const handleCloseSortModal = () => setSortModal(false);

  const [filterModal, setFilterModal] = useState(false);
  const handleOpenFilterModal = () => setFilterModal(true);
  const handleCloseFilterModal = () => setFilterModal(false);

  const [releModal, setReleModal] = useState(false);
  const handleOpenRelevanceModal = () => setReleModal(true);
  const handleCloseRelevanceModal = () => setReleModal(false);

  const [meetModal, setMeetModal] = useState(false);
  const [verifyGateOpen, setVerifyGateOpen] = useState(false);
  const handleOpenMeetModal = () => {
    if (["unverified", "resubmitted"].includes(user?.verificationStatus)) { setVerifyGateOpen(true); return; }
    setMeetModal(true);
  };
  const handleCloseMeetModal = () => setMeetModal(false);

  const [notesModal, setNotesModal] = useState(false);
  const handleOpenNotesModal = () => setNotesModal(true);
  const handleCloseNotesModal = () => setNotesModal(false);

  const [orderSort, setOrderSort] = useState("a-to-z");
  const [relevanceSort, setRelevanceSort] = useState("");
  const [search, setSearch] = useState("");
  const [email, setEmail] = useState("");
  const [addBuyersuccess, setAddBuyersuccess] = useState(false);
  const [resetSearch, setResetSearch] = useState(false);
  const [loading, setLoading] = useState(false);

  const [inputs, setInputs] = useState({ event: "", company: "", email: "" });
  const [newBuyer, setNewBuyer] = useState<any>({});
  const [meetingData, setMeetingData] = useState<any>([]);
  const [event, setEvent] = useState<EventInterface[]>([]);
  const [companies, setCompanies] = useState<any>([]);
  const [accordionActive, setAccordionActive] = useState("");
  const [sellerData, setSellerData] = useState<any>({});
  const [buyers, setBuyers] = useState<BuyerInterface[]>([]);
  const [allLeads, setAllLeads] = useState<BuyerInterface[]>([]);

  const [filterIndustry, setFilterIndustry] = useState<string>("");
  const [filterIndustryInput, setFilterIndustryInput] = useState<string>("");
  const [filterCountry, setFilterCountry] = useState<string>("");
  const [allIndustries, setAllIndustries] = useState<{ value: string; label: string }[]>([]);
  const [industryOptions, setIndustryOptions] = useState<{ value: string; label: string }[]>([]);
  const [countryOptions, setCountryOptions] = useState<{ value: string; label: string }[]>([]);

  const [meetResponder, setMeetResponder] = useState<any>();
  const [meetConfirm, setMeetConfirm] = useState(false);
  const handleOpenMeetConfirmModal = () => setMeetConfirm(true);
  const handleCloseMeetConfirmModal = () => { setMeetConfirm(false); setCurrentMeet(""); };

  const [addNewBuyer, setAddNewBuyer] = useState(false);
  const handleOpenBuyerAddModal = () => setAddNewBuyer(true);
  const handleCloseBuyerAddModal = () => { setAddNewBuyer(false); setNewBuyer({}); };

  const [currentMeet, setCurrentMeet] = useState("");
  const [userPlan, setUserPlan] = useState<any>({});
  const [notesData, setNotesData] = useState<any>({ forUser: "", eventId: "", companyName: "" });
  const [details, setDetails] = useState({ company: "", event: "" });


  const getPlanDetails = async () => {
    try {
      const planDetails = await SellerAPI.getEventSellerProfile(user.user);
      if (planDetails) setUserPlan(planDetails?.data?.data);
    } catch {
      error("Unable to get subscription details!");
    }
  };

  // Claude: replaced getEvents — now loads only events present in this seller's buyer list 20-03-2026
  const getEvents = async () => {
    try {
      setLoading(true);
      const [data, data2, data3] = await Promise.all([
        SellerAPI.getBuyerListEvents(),
        SellerAPI.getSellerProfile(),
        CommonAPI.GetMeeting({ status: undefined }),
      ]);
      if (data?.success) setEvent(data.data.data);
      if (data2) setSellerData(data2?.data?.data);
      if (data3) {
        const response = JSON.parse(JSON.stringify(data3?.data?.data));
        let meetingDataObj: any = {};
        response.forEach((element: any) => {
          meetingDataObj[element.responderCompany] = {
            _id: element._id,
            requesterId: element.requesterId,
            responderId: element.responderId,
            requesterStatus: element.requesterStatus,
            responderStatus: element.responderStatus,
          };
        });
        setMeetingData(meetingDataObj);
      }
    } catch (err: any) {
      error(errorHandler(err));
    }
  };

  const resetFilters = () => {
    if (search !== "") setResetSearch(!resetSearch);
    setSearch("");
    setOrderSort("a-to-z");
    if (orderSort === "z-to-a") filterToggleRef.current?.click();
    setRelevanceSort("");
    setInputs((prev) => ({ ...prev, event: "" }));
    setFilterIndustry("");
    setFilterIndustryInput("");
    setFilterCountry("");
  };

  // Claude: N13 — load flat industry list 01-03-2026
  const loadIndustries = async () => {
    try {
      const data = await CommonAPI.getIndustry();
      if (data?.success) {
        const opts = (data.data || []).map((n: any) => ({ value: String(n._id), label: n.name }));
        setAllIndustries(opts);
        setIndustryOptions(opts);
      }
    } catch {}
  };

  // Claude: D2 — load buyer leads from BuyerSellerMapping; group by company locally 26-02-2026
  const loadBuyerLeads = async () => {
    try {
      setLoading(true);
      const data = await SellerAPI.getBuyerLeads();
      if (data.success) {
        const allBuyers: BuyerInterface[] = data?.data?.data ?? [];
        const seen = new Set<string>();
        const distinctCountries = allBuyers
          .filter((b: any) => b?.buyerPersonCountry && !seen.has(b.buyerPersonCountry) && seen.add(b.buyerPersonCountry))
          .map((b: any) => ({ value: b.buyerPersonCountry as string, label: b.buyerPersonCountry as string }))
          .sort((a, b) => a.value.localeCompare(b.value));
        setCountryOptions(distinctCountries);
        groupBuyersByCompany(allBuyers, search, orderSort, relevanceSort, filterIndustry, filterCountry);
      }
    } catch (err: any) {
      error(errorHandler(err));
    } finally {
      setLoading(false);
      setAddBuyersuccess(false);
    }
  };

  // Claude: group flat buyer array into company accordion items locally 26-02-2026
  const groupBuyersByCompany = (
    allBuyers: BuyerInterface[],
    searchTerm: string,
    o: string,
    rel: string,
    industryId: string = "",
    country: string = "",
  ) => {
    let filtered = [...allBuyers];
    if (searchTerm) {
      const lower = searchTerm.toLowerCase();
      filtered = filtered.filter((b: any) =>
        b?.buyerCompanyName?.toLowerCase().includes(lower) || b?.buyerPersonName?.toLowerCase().includes(lower)
      );
    }
    if (industryId) filtered = filtered.filter((b: any) => (b?.industryIds || []).map(String).includes(industryId));
    if (country) filtered = filtered.filter((b: any) => b?.buyerPersonCountry?.toLowerCase() === country.toLowerCase());

    const map: Record<string, any[]> = {};
    filtered.forEach((b: any) => {
      const key = b?.buyerCompanyName || "Unknown";
      if (!map[key]) map[key] = [];
      map[key].push(b);
    });

    let grouped = Object.entries(map).map(([companyName, buyerList]) => ({
      companyName,
      buyers: buyerList.map((b: any) => ({ buyerId: b._id })),
      prequalificationStatus: buyerList[0]?.prequalificationStatus ?? "",
      eventId: "",
      _buyerDetails: buyerList,
    }));

    grouped.sort((a, b) => o === "z-to-a" ? b.companyName.localeCompare(a.companyName) : a.companyName.localeCompare(b.companyName));
    setCompanies(grouped);
    setAllLeads(allBuyers);
  };

  const buyerCompanyListItemClick = (companyName: string) => {
    const company = companies.find((c: any) => c.companyName === companyName);
    setBuyers(company?._buyerDetails ?? []);
    setNotesData({ ...notesData, eventId: "" });
    setDetails({ company: companyName, event: "" });
  };

  const searchEmail = async () => {
    if (!email) return;
    try {
      setLoading(true);
      const data = await SellerAPI.checkEmailExists({ email });
      if (data.success) {
        const { message } = data.data;
        // Claude: rewritten 24-03-2026 — messages aligned with updated backend responses
        if (message.toLowerCase().includes("buyer found") && data?.data?.data._id) {
          // Claude: verified buyer found and not yet in list — open confirmation modal 24-03-2026
          setNewBuyer(data.data.data);
          handleOpenBuyerAddModal();
        } else if (message.toLowerCase().includes("buyer already exists")) {
          error("Buyer already exists in your list.");
        } else if (message.toLowerCase().includes("buyer not found")) {
          // Claude: covers both "email not in DB" and "buyer not verified" cases 24-03-2026
          error("A verified buyer matching that email id is not found.");
        }
      }
    } catch (err: any) {
      error(errorHandler(err));
    } finally {
      setLoading(false);
    }
  };

  // Claude: eventId removed — event not mandatory 20-03-2026
  const addBuyer = async () => {
    try {
      const buyerId = newBuyer._id;
      if (!buyerId) return;
      const res = await SellerAPI.addNewBuyerToList({ buyerId, source: "direct" });
      if (res.success) {
        setNewBuyer({});
        setEmail("");
        handleCloseBuyerAddModal();
        setAddBuyersuccess(true);
        success("Buyer added successfully!");
      }
    } catch (err: any) {
      error(err?.message);
    }
  };

  useEffect(() => {
    const oSort = searchParams.get("o");
    const rSort = searchParams.get("r");
    setOrderSort(oSort || "a-to-z");
    setRelevanceSort(rSort || "");
    getEvents();
    getPlanDetails();
    loadBuyerLeads();
    loadIndustries();
    dispatch(actions.sellerMenu.set({ activeMenu: Sellerscreens.DETAILS }));
    isInitialRender.current = false;
  }, []);

  useEffect(() => { setSearchParams({ o: orderSort }); }, [orderSort]);
  useEffect(() => { if (addBuyersuccess) loadBuyerLeads(); }, [addBuyersuccess]);

  useEffect(() => {
    if (isInitialRender.current === false)
      groupBuyersByCompany(allLeads, search, orderSort, relevanceSort, filterIndustry, filterCountry);
  }, [orderSort, relevanceSort, resetSearch, filterIndustry, filterCountry]);

  return {
    navigate, user, filterToggleRef,
    relevanceData, setRelevanceData,
    sortModal, handleCloseSortModal,
    filterModal, handleCloseFilterModal,
    releModal, handleOpenRelevanceModal, handleCloseRelevanceModal,
    meetModal, verifyGateOpen, setVerifyGateOpen, handleOpenMeetModal, handleCloseMeetModal,
    notesModal, handleOpenNotesModal, handleCloseNotesModal,
    orderSort, setOrderSort, relevanceSort, setRelevanceSort,
    search, setSearch, email, setEmail,
    loading, inputs, setInputs, event, companies, accordionActive, setAccordionActive,
    sellerData, buyers, allLeads,
    filterIndustry, setFilterIndustry, filterCountry, setFilterCountry,
    industryOptions, countryOptions,
    meetResponder, setMeetResponder,
    meetConfirm, handleOpenMeetConfirmModal, handleCloseMeetConfirmModal,
    addNewBuyer, handleCloseBuyerAddModal, addBuyer,
    currentMeet, setCurrentMeet,
    userPlan, notesData, setNotesData, details,
    isNewMeetingAllowed, resetFilters, groupBuyersByCompany, buyerCompanyListItemClick, searchEmail,
    loadBuyerLeads, meetingData,
    error, success,
  };
};

export default useBuyersListState;
